export default {
  name: 'CookieBanner',

  data() {
    return {
      showCookie: false,
    };
  },

  mounted() {
    const hasCookie = document.cookie.includes('messagesCookies=true');

    if (!hasCookie) {
      setTimeout(() => {
        this.showCookie = true;
      }, 1500);
    }
  },

  methods: {
    acceptCookie() {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      document.cookie = `messagesCookies=true; expires=${date.toUTCString()}; path=/`;
      this.showCookie = false;
    },
  },
};
